function n(n) {
  var o = [];

  for (var r in n) {
    void 0 !== n[r] && null !== n[r] && o.push(r + "=" + encodeURIComponent(n[r]));
  }

  return o.join("&");
}

export { n as buildQuery };